import { Button } from '@/components/ui/button';
import { Checkbox } from '@/components/ui/checkbox';
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import z from 'zod';
import classes from './createAccount.module.css';

export function CreateAccountForm({ handleSubmit, isSubmitting }: { handleSubmit: any; isSubmitting: boolean }) {
  // 定义表单验证架构
  const formSchema = z
    .object({
      email: z.string().trim().email('Please enter a valid email address'),
      password: z.string().min(8, 'Password must be at least 8 characters'),
      confirmPassword: z.string(),
      newsletter: z.boolean().refine(val => val === true, {
        message: 'This is a required field',
      }),
      terms: z.boolean().refine(val => val === true, {
        message: 'You must agree to the terms and privacy policy',
      }),
    })
    .refine(data => data.password === data.confirmPassword, {
      message: 'Passwords do not match',
      path: ['confirmPassword'],
    });

  const form = useForm<z.infer<typeof formSchema>>({
    resolver: zodResolver(formSchema as any),
    defaultValues: {
      email: '',
      password: '',
      confirmPassword: '',
      newsletter: true,
      terms: true,
    },
  });

  function onSubmit(values: z.infer<typeof formSchema>) {
    handleSubmit({
      values: {
        customer: {
          email: values.email.trim(),
        },
        password: values.password,
        subscribe: values.newsletter,
        isAgree: values.terms,
      },
    });
  }

  return (
    <div className='w-full max-w-md space-y-6 text-left'>
      <div className='text-center  font-poppins text-[20px] font-bold uppercase text-primary lg_text-left lg_text-[30px]'>
        CREATE AN ACCOUNT
      </div>

      <Form {...form}>
        <form
          onSubmit={form.handleSubmit(onSubmit)}
          className='space-y-6 px-5 lg_px-0'
        >
          <FormField
            control={form.control}
            name='email'
            render={({ field }) => (
              <FormItem>
                <FormLabel
                  className='required font-poppins'
                  required
                >
                  EMAIL ADDRESS
                </FormLabel>
                <FormControl>
                  <Input
                    placeholder='your@email.com'
                    className='h-[54px] rounded-[10px] border-1 border-[#adadad]  bg-white'
                    {...field}
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />

          <FormField
            control={form.control}
            name='password'
            render={({ field }) => (
              <FormItem>
                <FormLabel
                  className='required font-poppins'
                  required
                >
                  PASSWORD
                </FormLabel>
                <FormControl>
                  <Input
                    type='password'
                    className='h-[54px] rounded-[10px] border-1 border-[#adadad]  bg-white'
                    {...field}
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />

          <FormField
            control={form.control}
            name='confirmPassword'
            render={({ field }) => (
              <FormItem>
                <FormLabel
                  className='required font-poppins'
                  required
                >
                  CONFIRM PASSWORD
                </FormLabel>
                <FormControl>
                  <Input
                    type='password'
                    className='h-[54px] rounded-[10px] border-1 border-[#adadad]  bg-white'
                    {...field}
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />

          <FormField
            control={form.control}
            name='newsletter'
            render={({ field }) => (
              <FormItem className='flex flex-row items-start space-x-3 space-y-0'>
                <FormControl>
                  <Checkbox
                    checked={field.value}
                    onCheckedChange={field.onChange}
                  />
                </FormControl>
                <div className='space-y-1 font-sans text-sm leading-none text-primary'>
                  <div className='flex flex-col gap-1'>
                    <FormLabel className='cursor-pointer'>
                      Follow us to receive exclusive offers and latest news
                    </FormLabel>
                    <FormMessage />
                  </div>
                </div>
              </FormItem>
            )}
          />

          <FormField
            control={form.control}
            name='terms'
            render={({ field }) => (
              <FormItem className='flex flex-row items-start space-x-3 space-y-0'>
                <FormControl>
                  <Checkbox
                    checked={field.value}
                    onCheckedChange={field.onChange}
                  />
                </FormControl>
                <div className='space-y-1 font-sans text-sm leading-none text-primary'>
                  <div className='flex flex-col gap-1'>
                    <FormLabel className='cursor-pointer'>
                      I agree Kingsyard&apos;s{' '}
                      <a
                        href='#'
                        className='underline'
                      >
                        Terms & Privacy
                      </a>{' '}
                      and{' '}
                      <a
                        href='#'
                        className='underline'
                      >
                        Privacy Policy
                      </a>
                    </FormLabel>
                    <FormMessage />
                  </div>
                </div>
              </FormItem>
            )}
          />

          <div className='flex flex-col gap-[10px]'>
            <Button
              type='submit'
              className='h-[54px] w-[220px] rounded-[10px] bg-primary text-center font-poppins font-[600] capitalize leading-[54px] text-white'
            >
              Create Account
            </Button>

            <div className={classes.newUsers}>10% OFF for new users</div>
          </div>
        </form>
      </Form>
    </div>
  );
}
